import type { BundleItem } from '../rewards/types';

export type FullPageDialogs =
  | 'store'
  | 'redeem'
  | 'account'
  | 'rewards'
  | 'prevent_purchase'
  | 'loyalty_program'
  | 'new_tier_congrats'
  | 'tier_monthly_bonus'
  | 'tier_birthday_gift'
  | 'bingo';
export type FullPageDialogsOptions = {
  isOpenFundsHistory?: boolean;
  from?: string;
  onClose?: VoidFunction;
};

export type Slide = FullPageDialogs | 'home';

export const enum EnumOpenDialog {
  isOpenChallengeDialog = 'isOpenChallengeDialog',
  isOpenKycDialog = 'isOpenKycDialog',
  isOpenOrderSummaryDialog = 'isOpenOrderSummaryDialog',
  isOpenPersonalDetailsDialog = 'isOpenPersonalDetailsDialog',
  isOpenCardDetailsDialog = 'isOpenCardDetailsDialog',
  isOpenTransactionFailedDialog = 'isOpenTransactionFailedDialog',
  isOpenPurchaseSuccessDialog = 'isOpenPurchaseSuccessDialog',
  isOpenKYCFailedDialog = 'isOpenKYCFailedDialog',
  isOpenClaimGiftDialog = 'isClaimGiftDialog',
  isOpenInvalidPromoDialog = 'isOpenInvalidPromoDialog',
  isOpenInviteFriendsDialog = 'isOpenInviteFriendsDialog',
  isOpenInviteFriendsBonusDialog = 'isOpenInviteFriendsBonusDialog',
  isOpenTransactionFailedDueToAddressDialog = 'isOpenTransactionFailedDueToAddressDialog',
  isOpenThirdPartyIframeDialog = 'isOpenThirdPartyIframeDialog',
  isOpenPurchaseLimitIncreaseDialog = 'isOpenPurchaseLimitIncreaseDialog',
  isOpenPurchaseLimitGiftDialog = 'isOpenPurchaseLimitGiftDialog',
  isOpenTransactionWaitingDialog = 'isOpenTransactionWaitingDialog',
  isOpenTokenExCvvOnlyDialog = 'isOpenTokenExCvvOnlyDialog',
  isOpenTournamentDialog = 'isOpenTournamentDialog',
  isOpenQuestDialog = 'isOpenQuestDialog',
  isOpenEditProfileDialog = 'isOpenEditProfileDialog',
  isOpenDailyMissionDialog = 'isOpenDailyMissionDialog',
  isOpenEventTriggerDialog = 'isOpenEventTriggerDialog',
  isOpenTermsOfService = 'isOpenTermsOfService',
  isOpenCoinBackDialog = 'isOpenCoinBackDialog',
  isOpenCoinBackBoosterDialog = 'isOpenCoinBackBoosterDialog',
  isOpenRedemptionApprovalDialog = 'isOpenRedemptionApprovalDialog',
  isOpenMinigamesDialog = 'isOpenMinigamesDialog',
  isOpenProfileInfoDialog = 'isOpenProfileInfoDialog',
  isOpenDailyMissionGrandPrizeGiftDialog = 'isOpenDailyMissionGrandPrizeGiftDialog',
  isOpenCoolDownDialog = 'isOpenCoolDownDialog',
  isOpenRedemptionActivationDialog = 'isOpenRedemptionActivationDialog',
  isOpenMetagamesDialog = 'isOpenMetagamesDialog',
  isOpenMonetizationEventsDialog = 'isOpenMonetizationEventsDialog',
  isOpenGameUiDialog = 'isOpenGameUiDialog',
  isOpenRedemptionExpiredDialog = 'isOpenRedemptionExpiredDialog',
  isOpenMarketingConsentDialog = 'isOpenMarketingConsentDialog',
  isOpenWelcomeBonusDialog = 'isOpenWelcomeBonusDialog',
  isOpenChooseCountryDialog = 'isOpenChooseCountryDialog',
  isOpenPromoCodeDialog = 'isOpenPromoCodeDialog',
  isOpenCancelSubscriptionDialog = 'isOpenCancelSubscriptionDialog',
  isOpenRedeemDialog = 'isOpenRedeemDialog',
  isOpenBingoEventsCalendarDialog = 'isOpenBingoEventsCalendarDialog',
  isOpenCashRedemptionHistoryDialog = 'isOpenRedemptionHistoryDialog',
  isOpenCrownPrimeIntroDialog = 'isOpenCrownPrimeIntroDialog',
  isOpenBingoPayTableDialog = 'isOpenBingoPayTableDialog',
  isOpenMyCardsDialog = 'isOpenMyCardsDialog',
  isOpenBingoResultsDialog = 'isOpenBingoResultsDialog',
  isOpenGameModeSelectionDialog = 'isOpenGameModeSelectionDialog',
}

export interface IOpenDialog {
  dialog: EnumOpenDialog | null;
  options?: {
    [key: string]: Record<string, unknown> | string | number | boolean | null | undefined | VoidFunction;
  };
}

export type AnimationProps = {
  fadeInDurationMs?: number;
  transitionDurationMs?: number;
};

export type XYPoint = { x: number; y: number };

export type LandingPos = {
  gcLandingPoint: XYPoint;
  scLandingPoint: XYPoint;
};

export type CoinsLandingPos = {
  gcLandingPoint: XYPoint;
  scLandingPoint: XYPoint;
};

export type ClaimableReward = {
  scCoin: number;
  gcCoin: number;
  bundleItems: BundleItem[];
};

export type ClaimRewardAnimationState = {
  enable: boolean;
  rewards?: ClaimableReward[];
  onEnd?: () => void | Promise<void>;
  refetchData?: boolean;
  enableSounds?: boolean;
  startMiniGames?: boolean;
};
